import { useAsync } from "@/shared/hooks/HookBase";
import { useCallback } from "react";
import type IIntegrationProvider from "../contracts/IIntegrationProvider";
import IntegrationProvidesService from "../services/integrationProvidesService";
import type IntegrationProvider from "../models/integrationProvider";
import type Page from "@/shared/models/Page";
import type PageRequest from "@/shared/models/PageRequest";

const integrationProviderService: IIntegrationProvider =
  new IntegrationProvidesService();

export function useIntegrationProviders() {
  const { loading, error, execute } = useAsync();

  const getAll = useCallback(
    async (
      pageRequest: PageRequest,
    ): Promise<Page<IntegrationProvider> | void> => {
      return await execute(() =>
        integrationProviderService.getAll(pageRequest),
      );
    },
    [execute],
  );

  const get = useCallback(
    async (id: string) => {
      return await execute(() => integrationProviderService.get(id));
    },
    [execute],
  );

  const create = useCallback(
    async (provider: Omit<IntegrationProvider, "id">) => {
      return await execute(() => integrationProviderService.create(provider), { successMessage: "Proveedor creado correctamente" });
    },
    [execute],
  );

  const update = useCallback(
    async (id: string, provider: Partial<IntegrationProvider>) => {
      return await execute(() =>
        integrationProviderService.update(id, provider),
        { successMessage: "Proveedor actualizado correctamente" },
      );
    },
    [execute],
  );

  const delete_ = useCallback(
    async (id: string) => {
      return await execute(() => integrationProviderService.delete(id), { successMessage: "Proveedor eliminado correctamente" });
    },
    [execute],
  );

  return {
    loading,
    error,
    getAll,
    get,
    create,
    update,
    delete: delete_,
  };
}
